import character from '../../images/character.svg';
import iconCard from '../../images/icon-card.svg';
import iconSearch from '../../images/icon-search.svg';
import iconNote from '../../images/icon-note.svg';
import iconStop from '../../images/icon-stop.svg';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as securityHelper from "../../helper/SecurityHelper";
import { fn_retrieveTodayWrkDclrDtl } from "../../api/FnCmmn";

export default function CardWorker({ setPassCard }: any) {
  const navigate = useNavigate();
  const user = securityHelper.getLoginUser();
  const passcardHandler = () => setPassCard(true);
  const tbmHandler = async () => {
    let smartTbmSeq = user.smartTbmSeq;
    let smartTbmSeqArr = smartTbmSeq.toString().split(',');
    let rtrnData = await axios.post('admin/api/tbm/retrieveTodayUserTbmDataList', { smartTbmSeq: smartTbmSeqArr[0] })
    let smartTbmData = rtrnData.data;
    if (user.wrkDclrSeq && user.wrkDclrSeq !== "0") {
      let wrkDclrSeqStr = user.wrkDclrSeq;
      let wrkDclrSeqArr = wrkDclrSeqStr.toString().split(',');
      let wrkDclrDtlList = await fn_retrieveTodayWrkDclrDtl(wrkDclrSeqArr);
      navigate('/smart-TBM', { state: { smartTbmSeq: user.smartTbmSeq, equipList: smartTbmData.equipChk, wrkDclrList: wrkDclrDtlList, doneTBM: true, authChange: false } });
    } else {
      navigate('/smart-TBM', { state: { smartTbmSeq: user.smartTbmSeq, noneWrkDclr: true, evntSeq: smartTbmData.evntSeq, sctrGb: smartTbmData.sctrGb, equipList: smartTbmData.equipChk, doneTBM: true, authChange: false } })
    }
  };
  const suggestHandler = () => {
    navigate('/sgst')
  };
  const workstopHandler = () => {
    navigate('/stop-request', { state: { isRequest: true } });
  };

  return (
    <>
      <div onClick={passcardHandler} className='hover:bg-white bg-[#2f2f35] hover:text-txtBlack hover:cursor-pointer text-white w-full h-[4.125rem] md:h-[165px] rounded-[8px] md:rounded-[22px] flex items-center mt-[0.563rem] md:mt-[22px] relative'>
        <img className='absolute top-[-72%] right-[0.1%] md:w-[145px] md:h-[207px]' src={character} alt='character' />
        <img className='w-[3.25rem] h-[3.25rem] ml-[1.375rem] md:w-[130px] md:h-[130px] md:ml-[55px]' src={iconCard} alt='icon1' />
        <p className='text-[0.938rem] md:text-[37px] font-extrabold ml-[0.938rem] mt-[0.313rem] md:ml-[37px] md:mt-[12px]'>내 출입증 확인</p>
      </div>
      <div onClick={tbmHandler} className='hover:bg-white bg-[#2f2f35] hover:text-txtBlack hover:cursor-pointer text-white w-full h-[4.125rem] md:h-[165px] rounded-[8px] md:rounded-[22px] flex items-center mt-[1.125rem] md:mt-[45px] '>
        <img className='w-[3.25rem] h-[3.25rem] ml-[1.375rem] md:w-[130px] md:h-[130px] md:ml-[55px]' src={iconNote} alt='icon2' />
        <p className='text-[0.938rem] md:text-[37px] font-extrabold ml-[0.938rem] mt-[0.313rem] md:ml-[37px] md:mt-[12px]'>TBM</p>
      </div>
      <div onClick={suggestHandler} className='hover:bg-white bg-[#2f2f35] hover:text-txtBlack hover:cursor-pointer text-white w-full h-[4.125rem] md:h-[165px] rounded-[8px] md:rounded-[22px] flex items-center mt-[1.125rem] md:mt-[45px] relative'>
        <img className='w-[3.25rem] h-[3.25rem] ml-[1.375rem] md:w-[130px] md:h-[130px] md:ml-[55px]' src={iconSearch} alt='icon3' />
        <p className='text-[0.938rem] md:text-[37px] font-extrabold ml-[0.938rem] mt-[0.313rem] md:ml-[37px] md:mt-[12px]'>건의사항</p>
      </div>
      <div onClick={workstopHandler} className='hover:bg-white bg-[#2f2f35] hover:text-txtBlack hover:cursor-pointer text-white w-full h-[4.125rem] md:h-[165px] rounded-[8px] md:rounded-[22px] flex items-center mt-[1.125rem] md:mt-[45px] '>
        <img className='w-[3.25rem] h-[3.25rem] ml-[1.375rem] md:w-[130px] md:h-[130px] md:ml-[55px]' src={iconStop} alt='icon4' />
        <p className='text-[0.938rem] md:text-[37px] font-extrabold ml-[0.938rem] mt-[0.313rem] md:ml-[37px] md:mt-[12px]'>작업중지요청</p>
      </div>
    </>
  );
}

